<template>
    <div>
        <div class="container mt-3">
            <b-card class="text-center">
                <b-row class="treasury-logo p-1" align-v="end">
                    <b-col cols="2">
                        <img class="p-1" src="~@/assets/images/grb.svg">
                    </b-col>
                    <b-col>
                        <div class="p-2">
                            <label>РЕПУБЛИКА СРБИЈА</label>
                            <label>МИНИСТАРСТВО ФИНАНСИЈА</label>
                            <label class="heavy-text">УПРАВА ЗА ТРЕЗОР</label>
                        </div>
                    </b-col>
                </b-row>
                <h3 class="mt-5 mb-3 heavier-text">Централни регистар фактура</h3>
                <br>

                <br>
                <p class="p-1">
                Министарство финансија спроводи мере и активности у вези са контролом преузетих обавеза у јавном сектору
                што између осталог подразумева евидентирање, праћење и извештавање о неизмиреним обавезама.
                За обављање поменутих активности успостављен је информациони систем под називом Централни регистар фактура (ЦРФ).
                </p>
                <br>
                <b-card bg-variant="warning" text-variant="white" class="text-center">
                  <b-card-text>
                    <span class="heavier-text"><b-link href='https://www.trezor.gov.rs/files/services/crf/Obave%C5%A1tenje%20%20KJS%20%E2%80%93%2014.03.2023.%20godine.pdf'>Хитно обавештење о поступању корисника јавних средстава</b-link></span>
                  </b-card-text>
                </b-card>
                <br>
                <b-card bg-variant="danger" text-variant="white" header="Обавезе корисника јавних средстава (КЈС) 01.05.2022. по Закону о електронском фактурисању" class="text-center">
                  <b-card-text>
                    Према одредбама Закона о електронском фактурисању („Сл. гласник РС”, бр. 44/2021 и 129/21), већина корисника јавних средстава сматрају се субјектима јавног сектора. <br>                    
                    <b-alert variant="success" class="my-3" show><strong>Од 1. маја 2022. године субјекти јавног сектора имаће обавезу да користе Систем електронских фактура, који омогућава и приступ и коришћење Централног регистра фактура. Период до ступања на снагу обавеза неопходно је искористити како би сви државни органи и организације, као и јавна предузећа, на време и у потпуности били спремни за почетак обавезне примене.</strong></b-alert>
                    <br>
                      <b-row><b-col class="text-center"><strong>Почетак примене права и обавеза:</strong></b-col></b-row><br>
                      <b-row>
                        <b-col class="text-left pl-3">
                         <strong>1.&nbsp;&nbsp;обавеза субјекта јавног сектора да прими и чува електронску фактуру издату у складу са Законом, обавеза издавања електронске фактуре другом субјекту јавног сектора, као и обавеза да електронски евидентира обрачун пореза на додату вредност, примењују се од <span style="text-decoration: underline;">1. маја 2022. године</span>, а регистровање примаоца <span style="text-decoration: underline;">по аутоматизму</span> за субјекте јавног сектора вршиће се непосредно уочи наведеног рока, <span style="text-decoration: underline;">уколико се претходно није регистровао</span>;</strong>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col class="text-left pl-3">
                        <strong>2.&nbsp;&nbsp;обавеза субјекта јавног сектора да изда електронску фактуру субјекту приватног сектора, у складу са Законом, примењује се од <span style="text-decoration: underline;">1. јула 2022. године.</span></strong>
                        </b-col>
                      </b-row>
                      <br>
                      <span>Субјект јавног сектора који има више нивоа сагласности и који не поседује свој систем, или део система за управљање фактурама, може да прима електронске фактуре преко <b-link href="https://www.efaktura.gov.rs/">Система за управљање фактурама</b-link>, који је бесплатан за коришћење.</span>
                      <br>
                      <br>
                      <b-row><b-col class="text-center"><strong>ВАЖНЕ НАПОМЕНЕ:</strong></b-col></b-row><br>
                      <b-row><b-col class="text-left pl-3">•&nbsp;&nbsp;&nbsp;&nbsp;<strong>Електронска фактура сматра се достављеном у тренутку издавања.</strong></b-col></b-row>
                      <b-row><b-col class="text-left pl-3">•&nbsp;&nbsp;&nbsp;&nbsp;Прималац електронске фактуре проверава послату електронску фактуру приступом систему електронских фактура и <strong>прихвата је или одбија у року од 15 дана</strong> од дана пријема електронске фактуре.</b-col></b-row>
                      <b-row><b-col class="text-left pl-3">•&nbsp;&nbsp;&nbsp;&nbsp;<strong>Ако прималац</strong> електронске фактуре који је субјект јавног сектора <strong>не прихвати или не одбије електронску фактуру</strong> издату од стране издаваоца електронске фактуре, електронска фактура по истеку рока од 15 дана аутоматски добија статус „прихваћена” и по закону сматра се прихваћеном.</b-col></b-row>
                      <b-row><b-col class="text-left pl-3">•&nbsp;&nbsp;&nbsp;&nbsp;Електронска фактура послата примаоцу путем система електронских фактура представља <strong>веродостојну исправу</strong>.</b-col></b-row>
                      <b-row><b-col class="text-left pl-3">•&nbsp;&nbsp;&nbsp;&nbsp;Све релевантне информације везане за електронско фактурисање доступне су на порталу еФактура на следећој адреси: <b-link href="https://www.efaktura.gov.rs/">https://www.efaktura.gov.rs/</b-link></b-col></b-row>
                  </b-card-text>
                </b-card>
                <hr>
                <p class="heavier-text" style="color: #aaaaaa;"> Погледајте <a style="color: gray;" href='/docs/user/register'>документацију за регистровање</a> правног лица</p>
            </b-card>
            <br>
            <b-row align-h="center" class="mt-3 heavier-text">
                <a :href="changelogPath">
                    <span>{{$t('general.changelog')}}</span>
                </a>
            </b-row>
            <b-row align-h="center" class="mt-5 heavier-text">
                <a :href="supportPath">
                    <span>{{$t('general.technicalSupport')}}</span>
                </a>
            </b-row>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { isUserActive, logout } from '@/router/auth'
  import { EventBus } from '@/router/bus'

  export default {
    name: 'startpage',
    data () {
      return {
        user: {},
        loginVisibility: 'none',
        loginError: false,
        connectionError: false,
        changelogPath: '',
        supportPath: '',
        integrationPath: ''
      }
    },
    created () {
      if (isUserActive()) {
        this.$router.push('/dashboard')
      } else {
        logout()
        EventBus.$emit('logged-out', '')
      }

      this.changelogPath = (Vue.$config.help_root + '/changelog/').replace(/([^:]\/)\/+/g, '$1')
      this.supportPath = (Vue.$config.help_root + '/support/').replace(/([^:]\/)\/+/g, '$1')
      this.integrationPath = (Vue.$config.help_root + '/integration/').replace(/([^:]\/)\/+/g, '$1')
    },
    methods: {
      register: function (e) {
        this.$router.push('/register')
      }
    }
  }

</script>

<style lang="scss">
    /*@import '../assets/css/login.scss';*/
    // @import '../assets/scss/main.scss';

    .treasury-logo {
        height: 75px;
        width: 260px;
        margin: 0 auto;
        img {
            width: 55px;
            height: 75px;
        }
        label {
            display: block;
            font-size: 8pt;
            font-weight: 600;
            margin: 0px;
        }
    }

    .heavy-text {
        font-weight: 800 !important;
    }

    .heavier-text {
        font-weight: 600;
    }

</style>



// WEBPACK FOOTER //
// StartPage.vue?56ff717c